<div class="slider">
    <ngx-slider [(value)]="startValue" (valueChange)="sliderValueChange($event)" [options]="options"></ngx-slider>
</div>
